import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {observer} from "mobx-react-lite";
import CursorContextProvider from "@/components/cursor/cursorContextProvider";
import appStyle from "./App.module.less";
import TsugieIdea from "@/screens/TsugieIdea";
import TsugiePrivacy from "@/screens/TsugiePrivacy";

function App() {
    return (
        <CursorContextProvider>
            <BrowserRouter>
                <div className={appStyle.App}>
                    <Routes>
                        <Route exact path="/" element={<TsugieIdea/>}/>
                        <Route exact path="/privacy" element={<TsugiePrivacy/>}/>
                        <Route exact path="/idea/tsugie" element={<Navigate to="/" replace/>}/>
                        <Route exact path="/idea/tsugie/privacy" element={<Navigate to="/privacy" replace/>}/>
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                    </Routes>
                </div>
            </BrowserRouter>
        </CursorContextProvider>
    );
}

export default observer(App);
